import { Button } from "@mui/material";
import TooltipForDisabledAction from "@entrilia/shared/components/TooltipForDisabledAction";
import type { PasswordResetGate } from "./portalAccessModel";

interface Props {
  gate: PasswordResetGate;
  hasPermissionsToManage: boolean;
  onClick: () => void;
}

const ResetPasswordButton = ({ gate, hasPermissionsToManage, onClick }: Props) => {
  if (!hasPermissionsToManage) {
    return null;
  }

  return (
    <TooltipForDisabledAction title={gate.tooltip} isActionDisabled={!gate.canReset}>
      <Button variant="outlined" disabled={!gate.canReset} onClick={onClick}>
        Reset password
      </Button>
    </TooltipForDisabledAction>
  );
};

export default ResetPasswordButton;
